import { EMPTY_OBJECT } from '../constants/app'

import getValueAtPath from './getValueAtPath'

const keyBy = <Data extends object>(
  items?: Data[],
  key?: string,
  getValue = (item: Data, _keyValue?: any) => item,
): Record<string, Data> => {
  return (
    items?.reduce((itemsByKey: Record<string, Data>, item) => {
      const keyValue = getValueAtPath(item, key || 'id')
      itemsByKey[keyValue] = getValue(item, keyValue)
      return itemsByKey
    }, {}) || EMPTY_OBJECT
  )
}

export default keyBy
